import { connect } from "react-redux";
import CustomerAddEdit from "./customer-add-edit";
import {
	onContactPersonChanged,
	onCustomerNameChanged,
	onEmailAddressChanged,
	onStatusChanged,
	onConsultantChanged,
	onClose,
	onSave,
	onSaveSuccessNotified,
} from "../actions";

const mapStateToProps = ({ customers }) => ({
	customer: customers.currentCustomer,
	isAddModalShowing: customers.isAddModalShowing,
	isEditModalShowing: customers.isEditModalShowing,
	saveError: customers.saveError,
	saveSuccessMessage: customers.saveSuccessMessage,
});

const mapDispatchToProps = {
	onContactPersonChanged,
	onCustomerNameChanged,
	onEmailAddressChanged,
	onStatusChanged,
	onConsultantChanged,
	onClose,
	onSave,
	onSaveSuccessNotified,
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerAddEdit);
